import Portail from '@/views/Portail';
import Portails from '@/views/Portails';
import PortailGroupe from '@/views/PortailGroupe';
import ListeEnseigne from '@/views/portailGroupe/ListeEnseigne';
import ListePointDeVente from '@/views/portailGroupe/ListePointDeVente';

import { PAGE_DEFAULT } from './routerConf';

export default [
  {
    path: '*',
    redirect: PAGE_DEFAULT,
  },
  {
    path: '/recom/:id',
    name: 'recom',
    component: Portail,
  },
  {
    path: '/portail/:hash',
    name: 'portailClient',
    component: Portails,
  },
  {
    path: '/portail-groupe',
    component: PortailGroupe,
    children: [
      {
        path: '',
        name: 'ListeEnseigne',
        component: ListeEnseigne,
      },
      {
        path: 'liste-point-de-vente/:id',
        name: 'ListePointDeVente',
        component: ListePointDeVente,
      },
    ],
  },
];
